import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrazyCallHeaders, StatsResponse } from './stats.model';
import { AppConfigService } from '../shared/services/app-config.service';
import { Observable } from 'rxjs/Observable';
import { CrazyCallConfigService } from '../shared/services/crazycall-config.service';
import { ReportFilters } from '../reports/report-filters/ReportFilters';
import { DateRange } from '../../shared/date-range-picker/date-range';
import { EmptyObservable } from 'rxjs-compat/observable/EmptyObservable';
import { disabledProgress } from '../../config/progress.inteceptor';

@Injectable()
export class StatsService {
  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
    private crazyCallConfigService: CrazyCallConfigService
  ) {}

  /* Currently API Gateway cannot correctly deserialize arrays in query params
    https://stackoverflow.com/questions/43401777/passing-array-query-parameters-with-api-gateway-to-lambda
    so we have to convert list to comma separated string manually
  */
  getStats(filters: ReportFilters): Observable<StatsResponse> {
    if (!filters.projects || !filters.projects.length) {
      return new EmptyObservable<StatsResponse>();
    }
    const projectIds = filters.projects.join(',');
    const dateParams = this.mapDateParams(filters.dateRange);

    const disableProgressBar = filters.liveModeEnabled ? disabledProgress : {};

    return this.http.get<StatsResponse>(this.statsUrl, {
      params: { account: this.crazyCallConfigService.account, ...dateParams, projectIds },
      ...disableProgressBar
    });
  }

  private get statsUrl() {
    return `${this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL}${
      this.crazyCallConfigService.appId
    }/reports/stats`;
  }

  private mapDateParams({ dateFrom, dateTo }: DateRange) {
    const params = { dateTo: dateTo.toISOString() };
    if (dateFrom && dateFrom.toISOString()) {
      params['dateFrom'] = dateFrom.toISOString();
    }
    return params;
  }
}
